import styled from '@emotion/styled'

export const LoanResultStyles = styled.div`
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  gap: 1rem;

  height: auto;
  padding: 1rem;

  background: #eee;

  .results {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .title {
    font-size: 1.125rem;
  }
  .text-color-primary {
    color: rgb(var(--colors-pink));
  }
  .installments {
    font-size: 1.5rem;
    margin: 1rem 0;
    font-weight: 600;
  }
  .value {
    font-size: 3rem;
    font-weight: 700;
  }
  .disclaimer {
    padding-top: 0.625rem;
    margin: 33px 30px 0;
    border-top: 1px solid #575755;
    font-size: 0.75rem;
  }
`
